export const Loader = {
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
};

export const PRE_LOAD_SERVICES = 'PRE_LOAD_SERVICES';
export const UPDATE_API_STATUS = 'UPDATE_API_STATUS';
export const CLEAR_REQUEST_LOG = 'CLEAR_REQUEST_LOG';
